import React from 'react'
import { RenderCommonUpload } from '../renderCommonUpload'

export const CollageBlockNineteen = ({IsSavedInputs,blockImages,setBlockImages,preview=false}) => {
  return (
    <div className={`w-full p-4 bg-gray-200 rounded-lg flex flex-col gap-4`}>
    <div className="w-full flex justify-evenly gap-4 h-[122px]">
      <div className="w-1/2 border-2 border-blue-500 h-full">
          <RenderCommonUpload buttonIndex={0} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
          setBlockImages={setBlockImages} preview={preview} dimension={"11.2:4.7"}/>
      </div>
      <div className="w-1/2 border-2 border-blue-500 h-full">
          <RenderCommonUpload buttonIndex={1} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
          setBlockImages={setBlockImages} preview={preview} dimension={"11.2:4.7"}/>
      </div>
    </div>
    <div className="w-full flex justify-evenly gap-4 h-[122px]">
      <div className="w-1/2 border-2 border-blue-500 h-full">
          <RenderCommonUpload buttonIndex={2} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
          setBlockImages={setBlockImages} preview={preview} dimension={"11.2:4.7"}/>
      </div>
      <div className="w-1/2 border-2 border-blue-500 h-full">
          <RenderCommonUpload buttonIndex={3} IsSavedInputs={IsSavedInputs} blockImages={blockImages} 
          setBlockImages={setBlockImages} preview={preview} dimension={"11.2:4.7"}/>
      </div>
    </div>
</div>
  )
}
